var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alertShow)?_c('div',{class:[_vm.state ? 'alert-green' : 'alert-red', 'alert-box']},[(_vm.state)?_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.state)?_c('i',{staticClass:"fa fa-times"}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fa0d528","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/tip/index.vue
// module id = null
// module chunks = 